import React, {useRef, useEffect, useState} from 'react'
import { TextField, IconButton, Card } from '@mui/material'
import SendIcon from '@mui/icons-material/Send';
import ChatMessage from './ChatMessage';
import { Button } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export default function Chat({confbridgeChannels, confbridgeChannelAvatars, confbridgeModerator, chatMessages, onSendChatMessage}) {
  const [hasNew, setHasNew] = useState(false)
  const [isBottom, setIsBottom] = useState(true)
  const inputRef = useRef()
  const messagesRef = useRef()
  const msgs = [].concat(chatMessages).reverse();

  useEffect(() => {
    if (chatMessages.length === 0) return
    setHasNew(true)
  }, [chatMessages])

  useEffect(() => {
    if (!messagesRef.current) return
    if (!hasNew) return
    if (!isBottom) return
    messagesRef.current.scrollTop = 0

  }, [messagesRef, hasNew, isBottom])

  const renderMessages = () => {
    return (
      msgs.map(message => {
        return (
          <ChatMessage key={message.Id} message={message} />
        )
      })
    )
  }

  return (
    <div className='live-call-chat'>
      <div 
        ref={messagesRef}
        className='live-call-chat-messages'
        onScroll={() => {
          if (messagesRef.current.scrollTop >= -5) {
            setHasNew(false)
            setIsBottom(prevState => {
              if (prevState === true) {
                return prevState
              } else {
                return true
              }
            })
          } else {
            setIsBottom(prevState => {
              if (prevState === false) {
                return prevState
              } else {
                return false
              }
            })
          } 
        }}
      >
        {renderMessages()}
      </div>
      {!isBottom && hasNew ?
        <div className='live-call-chat-jump-bottom'>
          <Button 
            color="primary"
            size="small"
            variant='contained'
            startIcon={<ArrowDownwardIcon />}
            onClick={() => {
              messagesRef.current.scrollTop = 0
              setHasNew(false)
            }}
          >
            Jump to new messages
          </Button>
        </div>
      : null}
      <div className='live-call-chat-controls'>
        <TextField
          inputRef={inputRef}
          fullWidth
          id="message-input"
          placeholder={
            confbridgeModerator ? "Disabled for Moderators.." : "Enter a message..."
          }
          multiline
          maxRows={8}
          onKeyDown={(e) => {
            if (e.key === "Enter" 
              && !e.shiftKey
              && inputRef.current.value.trim() !== ''
              ) {
              e.preventDefault()
              onSendChatMessage(inputRef.current.value);
              inputRef.current.value = "";
            }
          }}
          disabled={confbridgeModerator ? true : false}
        />
        <IconButton
            onClick={() => {
              onSendChatMessage(inputRef.current.value)
              inputRef.current.value = ''
            }}
            style={{width: '50px', height: '50px'}}
            disabled={confbridgeModerator ? true : false}
        >
          <SendIcon color='primary'/>
        </IconButton>
      </div>
    </div>
  )
}
